"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SwiftTheme = exports.SwiftLinkContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// original typescript
// import React, { createContext } from 'react'

// export const LinkContext = createContext(null)
// interface ILinker {
//   CustomLink: any

//   children: React.ReactNode
// }
// export const Linker = ({ CustomLink, children }: ILinker) => {
//   return <LinkContext.Provider value={CustomLink}>{children}</LinkContext.Provider>
// }

var SwiftLinkContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.SwiftLinkContext = SwiftLinkContext;
var SwiftTheme = /*#__PURE__*/(0, _react.createContext)({
  logo: {
    primary: "",
    secondary: ""
  },
  color: {
    primary: "#aa5ab8",
    // #5ab89e
    secondary: ""
  }
});
exports.SwiftTheme = SwiftTheme;
var SwiftProvider = function SwiftProvider(_ref) {
  var CustomLink = _ref.CustomLink,
    branding = _ref.branding,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SwiftLinkContext.Provider, {
    value: CustomLink,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SwiftTheme.Provider, {
      value: branding,
      children: children
    })
  });
};
var _default = SwiftProvider;
exports.default = _default;